import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { isEmpty, map } from "lodash";
import { withTranslation } from "react-i18next";
import EditLead from "./lead-edit";
import { Row,Col, Card, CardBody, Table, FormGroup, Label, Button, ButtonGroup,
  InputGroup, Offcanvas, OffcanvasHeader, OffcanvasBody} from "reactstrap";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { getLeadDetail,  convertLeadIntoClient,
    convertLeadIntoContact, } from "../../../store/actions";
import RsLink from "components/buttons/rsLink";
import backIcon from "../../../assets/images/rsicons/backIcon.png"
import editImg from "../../../assets/img/edit-new.png"
import CurrencyFormat from "react-currency-format";
import { hasPermission } from "helpers/checkPermission";
class leadLeftDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRight: false,
      isRight2: false,
      isRight3: false,
      isBackdrop: false,
      leadId: "",
      Id: "",
      ccTab:"1"
    };
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleRightCanvas2 = this.toggleRightCanvas2.bind(this);
    this.toggleRightCanvas3 = this.toggleRightCanvas3.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
  }

  toggleRightCanvas() {
    this.setState({ isRight: !this.state.isRight });
  }
  toggleRightCanvas2() {
    this.setState({ isRight2: !this.state.isRight2 });
  }

  toggleRightCanvas3() {
    this.setState({ isRight3: !this.state.isRight3 });
  }

  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  handleOnChange = value => {
    this.setState({
      volume: value,
    });
  };
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  cctoggle(tab) {
    if (this.state.ccTab !== tab) {
      this.setState({
        ccTab: tab,
      });
    }
  }

 
  componentDidMount() {
    const {
      match: { params }
    } = this.props;
    if (params && params.id && params.leadId) {
     
      this.setState({ leadId: params.leadId });
      this.setState({ Id: params.id });
    }
   
  }


  render() {
    const {leads,  userdetail, isMobile} = this.props;
    const allLocal = localStorage.getItem("localData");
    const localization = JSON.parse(allLocal);
    const userModule = localStorage.getItem("userModule");
    
    return (
      
      <React.Fragment>
              {isMobile ? (
                  <>
                      <Card className="overflow-hidden">
                 
                  <div className="">
                
                    <Row>
                      <Col sm="12">
                        <div className="">
                        {!isEmpty(leads) && (
                        <Card>
                          <CardBody style={{paddingTop:'0.5rem'}}>
                          <Link to="/lead/dashboard"><img src={backIcon}  width='16px' className="mdi mdi-home-import-outline ms-1"/></Link> {" "}
                             {hasPermission("RealtorLeads", "Edit") && (
                            <Link onClick={this.toggleRightCanvas} to="#" className="float-end"><img src={editImg}  width='16px' className="mdi mdi-home-import-outline ms-1"/></Link>
                              )}
                                 
                             
                          <div className="table-responsive">
                        <Table className="table mb-0 table-mobile">
                          <tbody>
                            <tr>
                              <th scope="row">Lead Status</th>
                              <td> {leads.leadStatusId > 1
                                  ? localization[
                                      "LeadStatus_" + leads.leadStatusId
                                    ]
                                  : "-"}{" "}</td>
                            </tr>
                            <tr>
                              <th scope="row">Lead Source</th>
                              <td>{leads.leadSourceId
                                  ? localization[
                                      "LeadSource_" + leads.leadSourceId
                                    ]
                                  : "-"}{" "}</td>
                            </tr>
                           
                            

                            <tr>
                              <th scope="row">Lead Stage</th>
                              <td>  {leads.stageId ? localization["LeadStage_" + leads.stageId ] : "-"} </td>
                            </tr>
                            <tr>
                              <th scope="row">Lead Group</th>
                              <td> {leads.group
                                  ? localization[
                                      "Lead_Group_" + leads.group
                                    ]
                                  : "-"}</td>
                            </tr>
                            <tr>
                              <th scope="row">Lead Type</th>
                              <td>
                                {" "}
                                {leads.leadTypeId
                                  ? localization["LeadType_" + leads.leadTypeId]
                                  : "-"}{" "}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row"> Name</th>
                              <td> {leads.firstName +" "+ leads.lastName} </td>
                            </tr>
                            <tr>
                              <th scope="row"> Address</th>
                              <td> {leads?.leadAddress?.fullAddress || "-"}</td>
                            </tr>
                           
                            

                            <tr>
                              <th scope="row"> Phone</th>
                              <td> {leads.phone || "-"} </td>
                            </tr>
                            <tr>
                              <th scope="row"> Mobile</th>
                              <td> {leads.mobile || "-"} </td>
                            </tr>
                            <tr>
                              <th scope="row"> Email</th>
                              <td> {leads.email || "-"} </td>
                            </tr>
                          
                            <tr>
                              <th scope="row">Deal Value</th>
                              <td>
                                 <CurrencyFormat
                                  value={leads.approxDealValue || 0}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  prefix={userdetail?.agentDefaultCurrencyCode ? userdetail.agentDefaultCurrencyCode + " " : "$"}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                />
                               
                               </td> 
                            </tr>
                            
                            <tr>
                              <th scope="row">Referred by</th>
                              <td>
                                {leads.referedBy || "-" }
                               </td> 
                            </tr>
                            <tr>
                              <th scope="row">Referral Code</th>
                              <td>
                                {leads.referralCode || "-"}
                               </td> 
                            </tr>         
                          </tbody>
                        </Table>
                      </div>
                          </CardBody>
                        </Card>
                     
                    )}
                         
                        </div>
                      </Col>
                     
                      
                    </Row>
                  </div>
                </Card>
                  </>
              ):(
                <>
                 <Card className="overflow-hidden">
                 
                  <div className="pt-3">
                
                    <Row>
                      <Col sm="12">
                        <div className="pt-2">
                        {!isEmpty(leads) && (
                        <Card>
                          <CardBody>
                          <Link to="/lead/dashboard"><img src={backIcon}  width='16px' className="mdi mdi-home-import-outline ms-1"/></Link>
                          <div className="table-responsive">
                        <Table className="table mb-0">
                          <tbody>
                            <tr>
                              <th scope="row"><strong>Lead Status</strong></th>
                              <td> {leads.leadStatusId > 1
                                  ? localization[
                                      "LeadStatus_" + leads.leadStatusId
                                    ]
                                  : "-"}{" "}</td>
                            </tr>
                            <tr>
                              <th scope="row"><strong>Lead Source</strong></th>
                              <td>{leads.leadSourceId
                                  ? localization[
                                      "LeadSource_" + leads.leadSourceId
                                    ]
                                  : "-"}{" "}</td>
                            </tr>
                           
                            

                            <tr>
                              <th scope="row"> <strong>Lead Stage</strong> </th>
                              <td>  {leads.stageId ? localization["LeadStage_" + leads.stageId ] : "-"} </td>
                            </tr>
                            <tr>
                              <th scope="row"> <strong>Lead Group</strong></th>
                              <td> {leads.group
                                  ? localization[
                                      "Lead_Group_" + leads.group
                                    ]
                                  : "-"}</td>
                            </tr>
                            <tr>
                              <th scope="row"><strong>Lead Type</strong></th>
                              <td>
                                {" "}
                                {leads.leadTypeId
                                  ? localization["LeadType_" + leads.leadTypeId]
                                  : "-"}{" "}
                              </td>
                            </tr>         
                          </tbody>
                        </Table>
                      </div>
                          </CardBody>
                        </Card>
                     
                    )}
                          <div className="float-end" style={{paddingRight:10, marginTop:10}}>

                                   {hasPermission("RealtorLeads", "Edit") && (  
                                    <RsLink onClick={this.toggleRightCanvas} className="btn-purpul w-md" iconClass="">Edit</RsLink>
                                   )}
                              
                          </div>
                        </div>
                      </Col>
                      <Col sm="12">
                        <div className="pt-2">
                          <div className="text-center">
                         
                              
                          
                          </div>
                        </div>
                      </Col>
                      
                    </Row>
                  </div>
                </Card>
                <Card>
                  <CardBody>
                    
                    <div className="clearfix"></div>
                    {!isEmpty(leads) && (
                      <div className="table-responsive">
                        <Table className="table mb-0">
                          <tbody>
                            <tr>
                              <th scope="row"> Name</th>
                              <td> {leads.firstName +" "+ leads.lastName} </td>
                            </tr>
                            <tr>
                              <th scope="row"> Address</th>
                              <td> {leads?.leadAddress?.fullAddress || "-"}</td>
                            </tr>
                           
                            

                            <tr>
                              <th scope="row"> Phone</th>
                              <td> {leads.phone || "-"} </td>
                            </tr>
                            <tr>
                              <th scope="row"> Mobile</th>
                              <td> {leads.mobile || "-"} </td>
                            </tr>
                            <tr>
                              <th scope="row"> Email</th>
                              <td> {leads.email || "-"} </td>
                            </tr>
                          
                            <tr>
                              <th scope="row">Deal Value</th>
                              <td>
                                 <CurrencyFormat
                                  value={leads.approxDealValue || 0}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  prefix={userdetail?.agentDefaultCurrencyCode ? userdetail.agentDefaultCurrencyCode + " " : "$"}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                />
                               
                               </td> 
                            </tr>
                            
                            <tr>
                              <th scope="row">Referred by</th>
                              <td>
                                {leads.referedBy || "-" }
                               </td> 
                            </tr>
                            <tr>
                              <th scope="row">Referral Code</th>
                              <td>
                                {leads.referralCode || "-"}
                               </td> 
                            </tr>
        
                          </tbody>
                        </Table>
                      </div>
                    )}
                  </CardBody>
                </Card>
                </>
              )
              
            }          
               
                <Offcanvas
                  isOpen={this.state.isRight}
                  direction="end"
                  toggle={this.toggleRightCanvas}
                  style={{width:800}}
                >
                  <OffcanvasHeader toggle={this.toggleRightCanvas}>
                    Update Lead
                  </OffcanvasHeader>
                  <OffcanvasBody>
                      <EditLead
                       closed={this.toggleRightCanvas} 
                       match={this.props.match}
                       leads={leads}
                       userdetail={userdetail}
                      />
                  </OffcanvasBody>
                </Offcanvas>

               
      </React.Fragment>
    );
  }
}
leadLeftDetail.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  leads: PropTypes.object,
  userdetail:PropTypes.object,
  isMobile:PropTypes.object
};
const mapStateToProps = ({ leads }) =>
  ({
     
  });
const mapDispatchToProps = dispatch => ({

});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(withTranslation()(leadLeftDetail)));
